/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { useHistory, useParams } from "react-router-dom";
import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";
import {
  Button,
  Paper,
  TextField,
  MenuItem,
  Checkbox,
  FormControlLabel,
  Typography,
} from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import SaveIcon from "@material-ui/icons/Save";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import AddPhotoAlternateIcon from "@material-ui/icons/AddPhotoAlternate";
import NoteAddIcon from "@material-ui/icons/NoteAdd";

import { ApiUrl } from "../../../api/api-url";
import { UrlCollection } from "../../../common/url-collection";
import * as appActions from "../../../core/app.store";
import ShowNotification from "../../../components/react-notifications/react-notifications";
import FilePickerDialog, {
  ImageExtensions,
  DocumentExtensions,
} from "../../../components/file-picker-dialog/file-picker-dialog.view";
import {
  NotificationMessageType,
  APIUrlDefault,
  MaxSizeImageUpload,
} from "../../../utils/configuration";
import * as viVN from "../../../language/vi-VN.json";
import { toSlug, getInvestmentErrorMessage, getFileUrl } from "../../../common/tools";
import * as projectAction from "../../../redux/store/investment-opportunity/investment-project.store";

import useInvestmentLookups from "./use-investment-lookups";
import { formatUtcDate } from "./list-investment-project.view";
import GalleryEditor from "./components/gallery-editor.view";
import DocumentEditor from "./components/document-editor.view";

const DefaultModel = {
  code: "",
  name: "",
  slug: "",
  shortDescription: "",
  description: "",
  avatarFileId: null,
  categoryId: "",
  statusId: "",
  investmentTypeId: "",
  investorId: null,
  area: "",
  areaUnit: "ha",
  address: "",
  investmentCapital: "",
  currency: "VND",
  latitude: "",
  longitude: "",
  legalStatus: "",
  infrastructureStatus: "",
  isFeatured: false,
  isActive: true,
};

const FilePicker = {
  Avatar: "avatar",
  Gallery: "gallery",
  Document: "document",
};

const EditorButtons = [
  [
    "undo", "redo", "font", "fontSize", "formatBlock", "paragraphStyle", "blockquote",
    "bold", "underline", "italic", "strike", "subscript", "superscript", "fontColor",
    "hiliteColor", "textStyle", "removeFormat", "outdent", "indent", "align",
    "horizontalRule", "list", "lineHeight", "table", "link", "image", "video",
    "fullScreen", "showBlocks", "codeView",
  ],
];

let newRowKey = 0;
const nextKey = () => "new-" + ++newRowKey;

const toInputString = (value) =>
  value === null || value === undefined ? "" : String(value);

const toNumberOrNull = (value) => {
  const text = String(value).trim();
  return text === "" ? null : Number(text);
};

const trimOrNull = (value) => {
  const text = (value || "").trim();
  return text === "" ? null : text;
};

const removeExtension = (fileName = "") => fileName.replace(/\.[^/.]+$/, "");

const isBlank = (value) => String(value).trim() === "";

const MissingFileMessage = "File đã bị xoá khỏi Quản lý tài liệu, hãy bỏ hoặc chọn lại";

const validate = (model, avatarFile, gallery, documents, lookups) => {
  const errors = {};
  const galleryErrors = {};
  const documentErrors = {};

  if (isBlank(model.code)) errors.code = "Trường này là bắt buộc";
  else if (model.code.trim().length > 50) errors.code = "Tối đa 50 ký tự";

  if (isBlank(model.name)) errors.name = "Trường này là bắt buộc";
  else if (model.name.trim().length > 255) errors.name = "Tối đa 255 ký tự";

  if (isBlank(toSlug(model.slug))) errors.slug = "Trường này là bắt buộc";
  else if (toSlug(model.slug).length > 255) errors.slug = "Tối đa 255 ký tự";

  // Backend chỉ nhận bản ghi đang hoạt động, kể cả khi sửa
  [
    ["categoryId", lookups.categories, "Danh mục"],
    ["statusId", lookups.statuses, "Trạng thái"],
    ["investmentTypeId", lookups.types, "Hình thức đầu tư"],
  ].forEach(([field, options, label]) => {
    if (!model[field]) {
      errors[field] = "Trường này là bắt buộc";
      return;
    }
    const selected = options.find((item) => String(item.id) === String(model[field]));
    if (selected && !selected.isActive) {
      errors[field] = `${label} này đã ngừng hoạt động, vui lòng chọn lại`;
    }
  });

  if (!isBlank(model.area)) {
    if (!/^\d+(\.\d{1,2})?$/.test(String(model.area).trim()))
      errors.area = "Số ≥ 0, tối đa 2 chữ số thập phân";
  }

  if (!isBlank(model.investmentCapital)) {
    const capital = String(model.investmentCapital).trim();
    if (!/^\d+(\.\d{1,2})?$/.test(capital))
      errors.investmentCapital = "Số ≥ 0, tối đa 2 chữ số thập phân";
    else if (Number(capital) > Number.MAX_SAFE_INTEGER)
      errors.investmentCapital = "Giá trị quá lớn";
  }

  if ((model.areaUnit || "").trim().length > 20) errors.areaUnit = "Tối đa 20 ký tự";
  if ((model.currency || "").trim().length > 10) errors.currency = "Tối đa 10 ký tự";
  if ((model.address || "").trim().length > 500) errors.address = "Tối đa 500 ký tự";

  const hasLat = !isBlank(model.latitude);
  const hasLng = !isBlank(model.longitude);
  if (hasLat !== hasLng) {
    const message = "Nhập cả vĩ độ và kinh độ, hoặc bỏ trống cả hai";
    if (!hasLat) errors.latitude = message;
    if (!hasLng) errors.longitude = message;
  }
  const coordinatePattern = /^-?\d+(\.\d{1,7})?$/;
  if (hasLat) {
    const lat = String(model.latitude).trim();
    if (!coordinatePattern.test(lat) || Math.abs(Number(lat)) > 90)
      errors.latitude = "Vĩ độ từ -90 đến 90, tối đa 7 chữ số thập phân";
  }
  if (hasLng) {
    const lng = String(model.longitude).trim();
    if (!coordinatePattern.test(lng) || Math.abs(Number(lng)) > 180)
      errors.longitude = "Kinh độ từ -180 đến 180, tối đa 7 chữ số thập phân";
  }

  // Backend từ chối fileId không còn tồn tại: chặn trước để báo rõ phần tử nào lỗi
  if (model.avatarFileId && !avatarFile) errors.avatar = MissingFileMessage;
  gallery.forEach((item, index) => {
    if (!item.file) galleryErrors[index] = MissingFileMessage;
  });
  if (Object.keys(galleryErrors).length > 0) errors.gallery = galleryErrors;

  documents.forEach((item, index) => {
    const rowErrors = {};
    if (isBlank(item.name)) rowErrors.name = "Tên tài liệu là bắt buộc";
    if (!item.file) rowErrors.file = MissingFileMessage;
    if (Object.keys(rowErrors).length > 0) documentErrors[index] = rowErrors;
  });
  if (Object.keys(documentErrors).length > 0) errors.documents = documentErrors;

  return errors;
};

const InvestmentProjectForm = ({ showLoading }) => {
  const history = useHistory();
  const { id } = useParams();
  const isEdit = !!id;
  const lookups = useInvestmentLookups();

  const [model, setModel] = useState(DefaultModel);
  const [initialDescription, setInitialDescription] = useState("");
  const [detail, setDetail] = useState(null);
  const [avatarFile, setAvatarFile] = useState(null);
  const [gallery, setGallery] = useState([]);
  const [documents, setDocuments] = useState([]);
  const [errors, setErrors] = useState({});
  const [isLoaded, setIsLoaded] = useState(!isEdit);
  const [isSlugTouched, setIsSlugTouched] = useState(isEdit);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [openPicker, setOpenPicker] = useState(null);
  const isMounted = useRef(true);

  useEffect(() => {
    isMounted.current = true;
    if (isEdit) loadDetail();
    return () => {
      isMounted.current = false;
    };
  }, [id]);

  const goToList = () => history.push(UrlCollection.InvestmentProject);

  const loadDetail = () => {
    showLoading(true);
    projectAction
      .GetDetailInvestmentProject(id)
      .then((res) => {
        showLoading(false);
        const content = res && res.content;
        if (!content || !isMounted.current) return;

        setDetail(content);
        setModel({
          code: content.code || "",
          name: content.name || "",
          slug: content.slug || "",
          shortDescription: content.shortDescription || "",
          description: content.description || "",
          avatarFileId: content.avatarFileId || null,
          categoryId: toInputString(content.category && content.category.id),
          statusId: toInputString(content.status && content.status.id),
          investmentTypeId: toInputString(
            content.investmentType && content.investmentType.id
          ),
          investorId: content.investorId || null,
          area: toInputString(content.area),
          areaUnit: content.areaUnit || "",
          address: content.address || "",
          investmentCapital: toInputString(content.investmentCapital),
          currency: content.currency || "",
          latitude: toInputString(content.latitude),
          longitude: toInputString(content.longitude),
          legalStatus: content.legalStatus || "",
          infrastructureStatus: content.infrastructureStatus || "",
          isFeatured: !!content.isFeatured,
          isActive: !!content.isActive,
        });
        setInitialDescription(content.description || "");
        setAvatarFile(content.avatarFile || null);

        const sortBySortOrder = (a, b) => (a.sortOrder || 0) - (b.sortOrder || 0);
        const galleryItems = [...(content.gallery || [])]
          .sort(sortBySortOrder)
          .map((item) => ({
            key: "g-" + item.id,
            id: item.id,
            fileId: item.fileId,
            file: item.file || null,
            title: item.title || "",
            description: item.description || "",
          }));
        const documentItems = [...(content.documents || [])]
          .sort(sortBySortOrder)
          .map((item) => ({
            key: "d-" + item.id,
            id: item.id,
            fileId: item.fileId,
            file: item.file || null,
            name: item.name || "",
            documentType: item.documentType || "",
            documentNumber: item.documentNumber || "",
            issuedDate: item.issuedDate ? String(item.issuedDate).substring(0, 10) : "",
            issuedBy: item.issuedBy || "",
            isPublic: !!item.isPublic,
          }));
        setGallery(galleryItems);
        setDocuments(documentItems);
        setIsLoaded(true);
      })
      .catch((err) => {
        showLoading(false);
        ShowNotification(
          err && err.status === 404
            ? "Dự án không tồn tại hoặc đã bị xoá."
            : getInvestmentErrorMessage(err),
          NotificationMessageType.Error
        );
        goToList();
      });
  };

  const setField = (field, value) => {
    setModel((prev) => {
      const next = { ...prev, [field]: value };
      if (field === "name" && !isSlugTouched) next.slug = toSlug(value);
      return next;
    });
    if (errors[field]) setErrors((prev) => ({ ...prev, [field]: undefined }));
  };

  const handleChange = (field) => (event) => setField(field, event.target.value);

  const handleChangeDescription = (content) => {
    setModel((prev) => ({
      ...prev,
      description: content === "<p><br></p>" ? "" : content,
    }));
  };

  const setAvatar = (file) => {
    setAvatarFile(file);
    setField("avatarFileId", file ? file.fileId : null);
    errors.avatar && setErrors((prev) => ({ ...prev, avatar: undefined }));
  };

  // files từ FileManagement: [{ fileId, fileName, filePreview }], cùng dạng Files backend trả về
  const handlePickFiles = (files) => {
    if (openPicker === FilePicker.Avatar) {
      setAvatar(files[0]);
    } else if (openPicker === FilePicker.Gallery) {
      setGallery((prev) => [
        ...prev,
        ...files.map((file) => ({
          key: nextKey(),
          id: 0,
          fileId: file.fileId,
          file,
          title: removeExtension(file.fileName),
          description: "",
        })),
      ]);
    } else if (openPicker === FilePicker.Document) {
      setDocuments((prev) => [
        ...prev,
        ...files.map((file) => ({
          key: nextKey(),
          id: 0,
          fileId: file.fileId,
          file,
          name: removeExtension(file.fileName),
          documentType: "",
          documentNumber: "",
          issuedDate: "",
          issuedBy: "",
          isPublic: true,
        })),
      ]);
    }
  };

  const buildBody = () => ({
    code: model.code.trim().toUpperCase(),
    name: model.name.trim(),
    slug: toSlug(model.slug),
    shortDescription: trimOrNull(model.shortDescription),
    description: trimOrNull(model.description),
    avatarFileId: model.avatarFileId || null,
    categoryId: Number(model.categoryId),
    statusId: Number(model.statusId),
    investmentTypeId: Number(model.investmentTypeId),
    investorId: model.investorId || null,
    area: toNumberOrNull(model.area),
    areaUnit: trimOrNull(model.areaUnit),
    address: trimOrNull(model.address),
    investmentCapital: toNumberOrNull(model.investmentCapital),
    currency: trimOrNull(model.currency),
    latitude: toNumberOrNull(model.latitude),
    longitude: toNumberOrNull(model.longitude),
    legalStatus: trimOrNull(model.legalStatus),
    infrastructureStatus: trimOrNull(model.infrastructureStatus),
    isFeatured: model.isFeatured,
    isActive: model.isActive,
    // Update coi gallery/documents là danh sách đầy đủ: luôn gửi lại toàn bộ, giữ id
    gallery: gallery.map((item, index) => ({
      id: item.id || 0,
      fileId: item.fileId,
      title: trimOrNull(item.title),
      description: trimOrNull(item.description),
      sortOrder: index,
    })),
    documents: documents.map((item, index) => ({
      id: item.id || 0,
      fileId: item.fileId,
      name: item.name.trim(),
      documentType: trimOrNull(item.documentType),
      documentNumber: trimOrNull(item.documentNumber),
      issuedDate: item.issuedDate || null,
      issuedBy: trimOrNull(item.issuedBy),
      sortOrder: index,
      isPublic: item.isPublic,
    })),
  });

  const onSubmit = (event) => {
    event.preventDefault();
    const validateErrors = validate(model, avatarFile, gallery, documents, lookups);
    setErrors(validateErrors);
    if (Object.keys(validateErrors).length > 0) {
      ShowNotification(
        "Vui lòng kiểm tra lại các trường được đánh dấu.",
        NotificationMessageType.Error
      );
      return;
    }

    const body = buildBody();
    setIsSubmitting(true);
    showLoading(true);
    const request = isEdit
      ? projectAction.UpdateInvestmentProject(id, body)
      : projectAction.CreateInvestmentProject(body);
    request
      .then(() => {
        showLoading(false);
        ShowNotification(
          isEdit
            ? viVN.Success.InvestmentProjectEditSuccess
            : viVN.Success.InvestmentProjectAddSuccess,
          NotificationMessageType.Success
        );
        goToList();
      })
      .catch((err) => {
        showLoading(false);
        setIsSubmitting(false);
        ShowNotification(
          getInvestmentErrorMessage(err),
          NotificationMessageType.Error
        );
      });
  };

  // Dropdown chỉ hiện bản ghi đang hoạt động, cộng bản ghi dự án đang dùng (nếu đã ngừng) để báo chọn lại
  const getMasterOptions = (options, currentId) =>
    options.filter((item) => item.isActive || String(item.id) === String(currentId));

  const renderMasterSelect = (field, label, options) => (
    <>
      <label className="text-dark">
        {label}
        <span className="required"></span>
      </label>
      <TextField
        select
        fullWidth
        value={model[field]}
        onChange={handleChange(field)}
        error={!!errors[field]}
      >
        {getMasterOptions(options, model[field]).map((item) => (
          <MenuItem key={item.id} value={String(item.id)} disabled={!item.isActive}>
            {item.name}
            {!item.isActive && " (đã ngừng hoạt động)"}
          </MenuItem>
        ))}
      </TextField>
      {errors[field] && <span className="error">{errors[field]}</span>}
    </>
  );

  // Chủ đầu tư đã tắt không có trong GetLookup nhưng vẫn hợp lệ: thêm tạm để không mất liên kết
  const investorOptions = (() => {
    const options = lookups.investors || [];
    if (
      model.investorId &&
      !options.some((item) => item.id === model.investorId) &&
      detail &&
      detail.investorId === model.investorId
    ) {
      return [
        ...options,
        { id: detail.investorId, name: (detail.investorName || "") + " (ngừng hoạt động)" },
      ];
    }
    return options;
  })();
  const selectedInvestor =
    investorOptions.find((item) => item.id === model.investorId) || null;

  const capitalHint =
    !isBlank(model.investmentCapital) && !isNaN(Number(model.investmentCapital))
      ? Number(model.investmentCapital).toLocaleString("vi-VN") + " " + (model.currency || "")
      : "";
  const hasNoMasterData =
    lookups.isLoaded &&
    (!lookups.categories.some((item) => item.isActive) ||
      !lookups.statuses.some((item) => item.isActive) ||
      !lookups.types.some((item) => item.isActive));

  if (!isLoaded) return null;

  return (
    <div className="slider">
      <form onSubmit={onSubmit} autoComplete="off">
        <div className="d-flex align-items-center justify-content-between mb-3">
          <Button type="button" variant="contained" startIcon={<ArrowBackIcon />} onClick={goToList}>
            Quay lại danh sách
          </Button>
          {detail && (
            <small className="text-muted">
              Tạo lúc {formatUtcDate(detail.createdDate)} · Cập nhật {formatUtcDate(detail.modifiedDate)}
            </small>
          )}
        </div>

        {hasNoMasterData && (
          <div className="alert alert-warning">
            Chưa có danh mục, trạng thái hoặc hình thức đầu tư đang hoạt động. Cần tạo ít nhất một bản
            ghi cho mỗi loại trước khi lưu dự án.
          </div>
        )}

        {/* Thông tin chung */}
        <Paper className="p-3 mb-3">
          <Typography variant="h6" className="mb-3">Thông tin chung</Typography>
          <div className="row">
            <div className="form-group col-md-3">
              <label className="text-dark">
                Mã dự án<span className="required"></span>
              </label>
              <TextField
                fullWidth
                value={model.code}
                onChange={handleChange("code")}
                onBlur={() => setField("code", model.code.trim().toUpperCase())}
                inputProps={{ maxLength: 50 }}
                error={!!errors.code}
              />
              {errors.code && <span className="error">{errors.code}</span>}
            </div>
            <div className="form-group col-md-9">
              <label className="text-dark">
                Tên dự án<span className="required"></span>
              </label>
              <TextField
                fullWidth
                value={model.name}
                onChange={handleChange("name")}
                inputProps={{ maxLength: 255 }}
                error={!!errors.name}
              />
              {errors.name && <span className="error">{errors.name}</span>}
            </div>
            <div className="form-group col-12">
              <label className="text-dark">
                Slug<span className="required"></span>
              </label>
              <TextField
                fullWidth
                value={model.slug}
                onChange={(e) => {
                  setIsSlugTouched(true);
                  setField("slug", e.target.value);
                }}
                onBlur={() => setField("slug", toSlug(model.slug))}
                inputProps={{ maxLength: 255 }}
                error={!!errors.slug}
                helperText="Tự sinh từ tên dự án, có thể sửa. Dùng làm đường dẫn trang chi tiết ở web người dùng."
              />
              {errors.slug && <span className="error">{errors.slug}</span>}
            </div>
            <div className="form-group col-md-4">
              {renderMasterSelect("categoryId", "Danh mục", lookups.categories)}
            </div>
            <div className="form-group col-md-4">
              {renderMasterSelect("statusId", "Trạng thái dự án", lookups.statuses)}
            </div>
            <div className="form-group col-md-4">
              {renderMasterSelect("investmentTypeId", "Hình thức đầu tư", lookups.types)}
            </div>
            <div className="form-group col-md-6">
              <label className="text-dark">Chủ đầu tư</label>
              <Autocomplete
                options={investorOptions}
                getOptionLabel={(option) => option.name || ""}
                value={selectedInvestor}
                onChange={(event, newValue) =>
                  setField("investorId", newValue ? newValue.id : null)
                }
                renderInput={(params) => (
                  <TextField {...params} placeholder="Chưa có chủ đầu tư" />
                )}
              />
            </div>
            <div className="form-group col-md-6 d-flex align-items-end">
              <FormControlLabel
                control={
                  <Checkbox
                    checked={model.isFeatured}
                    onChange={(e) => setField("isFeatured", e.target.checked)}
                    color="primary"
                  />
                }
                label="Dự án nổi bật"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={model.isActive}
                    onChange={(e) => setField("isActive", e.target.checked)}
                    color="primary"
                  />
                }
                label="Hiển thị trên web người dùng"
              />
            </div>
            <div className="form-group col-12">
              <label className="text-dark">Mô tả ngắn</label>
              <textarea
                rows="3"
                className="form-control"
                value={model.shortDescription}
                onChange={handleChange("shortDescription")}
              />
            </div>
          </div>
        </Paper>

        {/* Quy mô và vị trí */}
        <Paper className="p-3 mb-3">
          <Typography variant="h6" className="mb-3">Quy mô và vị trí</Typography>
          <div className="row">
            <div className="form-group col-md-3">
              <label className="text-dark">Diện tích</label>
              <TextField
                fullWidth
                type="number"
                value={model.area}
                onChange={handleChange("area")}
                inputProps={{ min: 0, step: "0.01" }}
                error={!!errors.area}
              />
              {errors.area && <span className="error">{errors.area}</span>}
            </div>
            <div className="form-group col-md-2">
              <label className="text-dark">Đơn vị</label>
              <TextField
                fullWidth
                value={model.areaUnit}
                onChange={handleChange("areaUnit")}
                inputProps={{ maxLength: 20 }}
                error={!!errors.areaUnit}
              />
              {errors.areaUnit && <span className="error">{errors.areaUnit}</span>}
            </div>
            <div className="form-group col-md-5">
              <label className="text-dark">Vốn đầu tư</label>
              <TextField
                fullWidth
                type="number"
                value={model.investmentCapital}
                onChange={handleChange("investmentCapital")}
                inputProps={{ min: 0 }}
                error={!!errors.investmentCapital}
                helperText={!errors.investmentCapital && capitalHint}
              />
              {errors.investmentCapital && (
                <span className="error">{errors.investmentCapital}</span>
              )}
            </div>
            <div className="form-group col-md-2">
              <label className="text-dark">Tiền tệ</label>
              <TextField
                fullWidth
                value={model.currency}
                onChange={handleChange("currency")}
                inputProps={{ maxLength: 10 }}
                error={!!errors.currency}
              />
              {errors.currency && <span className="error">{errors.currency}</span>}
            </div>
            <div className="form-group col-12">
              <label className="text-dark">Địa chỉ</label>
              <TextField
                fullWidth
                value={model.address}
                onChange={handleChange("address")}
                inputProps={{ maxLength: 500 }}
                error={!!errors.address}
              />
              {errors.address && <span className="error">{errors.address}</span>}
            </div>
            <div className="form-group col-md-4">
              <label className="text-dark">Vĩ độ (latitude)</label>
              <TextField
                fullWidth
                type="number"
                value={model.latitude}
                onChange={handleChange("latitude")}
                inputProps={{ step: "any" }}
                placeholder="16.6412345"
                error={!!errors.latitude}
              />
              {errors.latitude && <span className="error">{errors.latitude}</span>}
            </div>
            <div className="form-group col-md-4">
              <label className="text-dark">Kinh độ (longitude)</label>
              <TextField
                fullWidth
                type="number"
                value={model.longitude}
                onChange={handleChange("longitude")}
                inputProps={{ step: "any" }}
                placeholder="107.3712345"
                error={!!errors.longitude}
              />
              {errors.longitude && <span className="error">{errors.longitude}</span>}
            </div>
            <div className="form-group col-md-4 d-flex align-items-end">
              {!isBlank(model.latitude) && !isBlank(model.longitude) && (
                <a
                  href={`https://www.google.com/maps?q=${model.latitude.trim()},${model.longitude.trim()}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Kiểm tra vị trí trên Google Maps
                </a>
              )}
            </div>
            <div className="form-group col-md-6">
              <label className="text-dark">Tình trạng pháp lý</label>
              <textarea
                rows="3"
                className="form-control"
                value={model.legalStatus}
                onChange={handleChange("legalStatus")}
              />
            </div>
            <div className="form-group col-md-6">
              <label className="text-dark">Hiện trạng hạ tầng</label>
              <textarea
                rows="3"
                className="form-control"
                value={model.infrastructureStatus}
                onChange={handleChange("infrastructureStatus")}
              />
            </div>
          </div>
        </Paper>

        {/* Ảnh đại diện */}
        <Paper className="p-3 mb-3">
          <Typography variant="h6" className="mb-3">Ảnh đại diện</Typography>
          <div className="d-flex align-items-center">
            <div
              className="mr-3 d-flex align-items-center justify-content-center bg-light border"
              style={{ width: 200, height: 130 }}
            >
              {avatarFile && avatarFile.filePreview ? (
                <img
                  src={getFileUrl(avatarFile.filePreview)}
                  alt={avatarFile.fileName}
                  style={{ maxWidth: "100%", maxHeight: "100%" }}
                />
              ) : (
                <small className={model.avatarFileId ? "text-danger" : "text-muted"}>
                  {model.avatarFileId ? "File không tồn tại" : "Chưa có ảnh"}
                </small>
              )}
            </div>
            <div>
              <Button
                type="button"
                variant="contained"
                color="primary"
                className="mr-2"
                onClick={() => setOpenPicker(FilePicker.Avatar)}
              >
                Chọn ảnh
              </Button>
              {model.avatarFileId && (
                <Button type="button" variant="contained" onClick={() => setAvatar(null)}>
                  Bỏ ảnh
                </Button>
              )}
              {errors.avatar && <span className="error d-block mt-2">{errors.avatar}</span>}
            </div>
          </div>
        </Paper>

        {/* Mô tả chi tiết */}
        <Paper className="p-3 mb-3">
          <Typography variant="h6" className="mb-3">Mô tả chi tiết</Typography>
          <SunEditor
            enableToolbar={true}
            showToolbar={true}
            setContents={initialDescription}
            videoFileInput={false}
            setOptions={{
              height: 400,
              imageUploadUrl: APIUrlDefault + ApiUrl.UrlUploadFromEditor,
              imageUploadSizeLimit: MaxSizeImageUpload,
              imageAccept: ".jpg,.jpeg,.png,.gif,.svg",
              buttonList: EditorButtons,
            }}
            onChange={handleChangeDescription}
          />
        </Paper>

        {/* Thư viện ảnh */}
        <Paper className="p-3 mb-3">
          <div className="d-flex align-items-center justify-content-between mb-3">
            <Typography variant="h6">Thư viện ảnh ({gallery.length})</Typography>
            <Button
              type="button"
              variant="contained"
              color="primary"
              startIcon={<AddPhotoAlternateIcon />}
              onClick={() => setOpenPicker(FilePicker.Gallery)}
            >
              Thêm ảnh
            </Button>
          </div>
          <GalleryEditor
            items={gallery}
            errors={errors.gallery}
            onChange={(items) => {
              setGallery(items);
              errors.gallery && setErrors((prev) => ({ ...prev, gallery: undefined }));
            }}
          />
        </Paper>

        {/* Tài liệu pháp lý */}
        <Paper className="p-3 mb-3">
          <div className="d-flex align-items-center justify-content-between mb-3">
            <Typography variant="h6">Tài liệu ({documents.length})</Typography>
            <Button
              type="button"
              variant="contained"
              color="primary"
              startIcon={<NoteAddIcon />}
              onClick={() => setOpenPicker(FilePicker.Document)}
            >
              Thêm tài liệu
            </Button>
          </div>
          <p className="text-muted small">
            Chỉ tài liệu được đánh dấu "Công khai" mới hiển thị ở web người dùng.
          </p>
          <DocumentEditor
            items={documents}
            errors={errors.documents}
            onChange={(items) => {
              setDocuments(items);
              errors.documents && setErrors((prev) => ({ ...prev, documents: undefined }));
            }}
          />
        </Paper>

        <div className="d-flex justify-content-end mb-4">
          <Button type="button" variant="contained" className="mr-2" onClick={goToList}>
            Hủy
          </Button>
          <Button
            type="submit"
            color="primary"
            variant="contained"
            startIcon={<SaveIcon />}
            disabled={isSubmitting || !lookups.isLoaded}
          >
            Lưu
          </Button>
        </div>
      </form>

      {openPicker && (
        <FilePickerDialog
          isOpen={!!openPicker}
          onClose={() => setOpenPicker(null)}
          onConfirm={handlePickFiles}
          multiple={openPicker !== FilePicker.Avatar}
          acceptedFiles={openPicker === FilePicker.Document ? DocumentExtensions : ImageExtensions}
          title={
            openPicker === FilePicker.Avatar
              ? "Chọn ảnh đại diện"
              : openPicker === FilePicker.Gallery
              ? "Chọn ảnh cho thư viện"
              : "Chọn tài liệu"
          }
        />
      )}
    </div>
  );
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      showLoading: appActions.ShowLoading,
    },
    dispatch
  );

export default connect(null, mapDispatchToProps)(InvestmentProjectForm);
